export enum NavigationItems {
  PRIMARY_BUTTON = 'Primary Button',
  SECONDARY_BUTTON = 'Secondary Button',
  TERTIARY_BUTTON = 'Tertiary Button',
  LINK = 'Link',
  OTHER = 'Other',
  PRIMARY_BUTTON_OR_ENTER = 'Primary Button or Enter',
  TABS = 'Tabs',
  STEP_LOCATOR = 'Step Locator',
  OVERFLOW_MENU = 'OverflowMenu',
  OVERLAY = 'Overlay',
  SMART_BAR = 'SmartBar',
  NAVIGATIONAL_BUTTON = 'Navigational Button',
  PRODUCT_CARD = 'Product Card'
}
